import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PaysafeModule } from "./paysafe.module";
import { CoreModule } from "../core/core.module";
import { PaysafeService } from "@modules/paysafe/services/paysafe.service";
import { Paysafe3DSModalComponent } from "./components/paysafe-3ds-modal/paysafe-3ds-modal.component";
import { PaysafeStandardService } from "@modules/paysafe/services/paysafe-standard.service";

@NgModule({
	declarations: [Paysafe3DSModalComponent],
	imports: [CommonModule, PaysafeModule, CoreModule],
	providers: [
		PaysafeStandardService,
		{
			provide: PaysafeService,
			useExisting: PaysafeStandardService
		}
	]
})
export class PaysafeFlowModule {}
